export default {
  general: {
    settings: "Paramètres",
    show_time: "Afficher l'heure",
    show_seconds: "Afficher les secondes",
    show_search: "Afficher la barre de recherche",
    show_wallpaper: "Afficher le bouton de changement de fond d'écran",
    show_bookmark: "Afficher le bouton de favoris",
    show_weather: "Afficher la météo",
    show_top_sites: "Afficher les sites fréquemment visités",
    auto_change_background: "Changer automatiquement le fond d’écran",
    auto_change_every: "Changer tous les",
    days: "jours",
    hours: "heures",
    minutes: "minutes",
    interval_required: "Les jours, heures et minutes ne peuvent pas tous être à 0",
    sync_enabled: "Synchronisation cloud des tâches",
    show_ai_chat: "Afficher le bouton de chat IA",
  },
  profile: {
    title: "Profil",
    logout: "Déconnexion",
    sign_in: "Connexion",
    sign_in_desc: "Veuillez vous connecter pour débloquer l'expérience complète",
    avatar_updated: "Avatar mis à jour avec succès",
    nickname_updated: "Pseudonyme mis à jour avec succès",
    avatar_size: "La taille du fichier d'avatar ne doit pas dépasser 500 Ko",
    login_required: "Vous devez être connecté pour mettre à jour votre avatar",
    login_success: "Connexion réussie",
    user_avatar: "Avatar de l'utilisateur",
    edit_avatar: "Modifier l'avatar",
    save: "Enregistrer",
    cancel: "Annuler"
  },
  subscription: {
    title: "Abonnement",
    check: "Vérifier mon abonnement",
    upgrade: "Améliorer l'abonnement",
    subscribe: "S'abonner à Tabby",
    expired_on: "Expiré le : {0}",
    expires_on: "Expire le : {0}",
    plans: {
      premium: "Débloquez tout Tabby : fonds d'écran illimités, fonds personnalisés et collections exclusives.",
      pro: "Améliorez votre abonnement pour débloquer des fonds d'écran illimités, des fonds personnalisés et des collections exclusives.",
      free: "Abonnez-vous pour débloquer des fonds d'écran illimités, des fonds personnalisés et des collections exclusives."
    }
  },
  wallpaper: {
    title: "Fond d'écran",
    upload: "Télécharger un fond personnalisé",
    upgrade_required: "Passez au plan Pro/Premium pour débloquer la fonction de fond personnalisé",
    images: "Images",
    hues: "Teintes",
    anims: "Animations",
    diy: "Personnalisé",
    get_new: "Obtenir un nouveau",
    upload_background: "Télécharger un fond",
    add: "Ajouter",
    remote_url: "URL d'image distante",
    size_tip: "Des fichiers de fond plus petits chargent les onglets plus rapidement. La plupart des navigateurs ont une limite de taille de fichier de 1,5 Mo. Les URL distantes n'ont pas de restrictions.",
    please_login: "Veuillez d'abord vous connecter",
    click_to_upload: "Cliquez pour télécharger",
    video_gif_image: "vidéo, GIF ou image",
    background: "fond",
    or_enter_remote_background_url: "Ou entrez l'URL d'un fond distant",
    remote_url_placeholder: "https://example.com/image.jpg",
    custom_background_removed: "Fond personnalisé supprimé",
    failed_to_load_background: "Échec du chargement du fond",
    using_default: "Utilisation du fond par défaut à la place",
    insufficient_storage: "Stockage insuffisant",
    upload_failed: "Échec du téléchargement",
    success: "Succès",
    remote_background_added: "Fond distant ajouté",
    detecting_media_type: "Détection du type de média...",
    invalid_media_type: "Type de média non reconnu",
    video_load_failed: "La vidéo ne peut pas être chargée, veuillez vérifier si l'URL est correcte"
  },
  rewards: {
    title: "Récompenses",
    invite_friends: "Inviter des amis",
    get_access: "Invitez des amis et débloquez des remises sur Pro",
    total_invites: "Invitations totales",
    your_discount: "Votre remise",
    no_pro_yet: "Aucune pour l'instant",
    copy_link: "Copier le lien d'invitation",
    copied: "Lien d'invitation copié !",
    copy_failed: "Échec de la copie du lien",
    invite_description: "Un ami s'inscrit avec votre lien",
    receive_credits: "Vous obtenez : 1 invitation → −5 %, 2 → −8 %, 3 → −15 %, 4+ → −20 % · Chaque ami obtient −5 %"
  },
  paywall: {
    title: "Tabby Pro",
    pro_active: "PRO ACTIF",
    expires: "expire",
    free_plan: "PLAN GRATUIT",
    tagline: "Débloquez des quotas de chat complets, la synchronisation des tâches dans le cloud et toutes les fonctions de fonds d'écran dans cette extension.",
    monthly: "MENSUEL",
    yearly: "ANNUEL",
    month_period: "/mois",
    year_period: "/an",
    billed_monthly: "Facturation mensuelle · annulable à tout moment",
    billed_yearly: "Facturation annuelle",
    checkout_usd: "Paiement",
    save_yearly: "Économisez 17 % vs mensuel",
    best_value: "MEILLEURE VALEUR",
    referral_price: "Prix parrainage",
    save: "économisez",
    subscribe_now: "S'abonner maintenant",
    current_plan: "Plan actuel",
    processing: "Traitement",
    waiting_title: "En attente du paiement",
    waiting_desc: "Veuillez terminer le paiement dans la fenêtre nouvellement ouverte.",
    payment_completed: "Paiement terminé",
    having_issues: "J'ai un problème",
    invite_save: "Invitez des amis et économisez sur Pro",
    sign_in_first: "Veuillez d'abord vous connecter",
    checkout_failed: "Impossible de créer la session de paiement",
    payment_failed: "Paiement échoué",
    payment_wrong: "Quelque chose s'est mal passé. Veuillez réessayer.",
    success_msg: "Félicitations ! Paiement réussi",
    not_paid_msg: "Le paiement n'est pas encore terminé. Terminez le paiement dans la fenêtre ou réessayez.",
    verify_failed: "Impossible de vérifier le statut du paiement. Réessayez ou contactez l'assistance.",
    contact_email: "Contactez-nous par e-mail : hi@tabbyio.com"
  },
  about: {
    title: "À propos",
    version: "Version : 1.3.11",
    contact: "Contactez-nous :",
    privacy_policy: "Politique de confidentialité",
    terms_of_service: "Conditions d'utilisation"
  },
  tabs: {
    general: "Préférences",
    profile: "Profil",
    wallpaper: "Fond d'écran",
    rewards: "Récompenses",
    about: "À propos"
  },
  language: {
    title: "Langue",
    en: "English",
    zh: "中文",
    de: "Deutsch",
    fr: "Français",
    pt: "Português",
    ru: "Русский",
    bn: "বাংলা",
    ja: "日本語",
    es: "Español"
  },
  buttons: {
    bookmark: "Favoris",
    next_background: "Fond suivant",
    ai_chat: "Chat IA",
    search_placeholder: "Recherchez ou appuyez sur Ctrl + Entrée pour le chat IA...",
    attach: "Joindre un fichier",
  },
  top_sites: {
    title: "Sites fréquemment visités",
    error: "Impossible de charger les sites fréquemment visités",
    empty: "Aucun site fréquemment visité trouvé"
  },
  greetings: {
    morning: "Bonjour",
    afternoon: "Bon après-midi",
    evening: "Bonsoir",
    morning_message: "Un nouveau jour commence, comment puis-je vous aider ?",
    afternoon_message: "L'après-midi, avez-vous des questions à poser ?",
    evening_message: "Le soir, laissez-moi discuter avec vous !"
  },
  intro: {
    your_portal: "Votre portail",
    for: "pour",
    productivity: "la productivité.",
    inspiration: "l'inspiration.",
    photography: "la photographie.",
    description: "Où chaque nouvel onglet devient une passerelle",
    description_continued: "vers l'élégance, la productivité et au-delà.",
    add_to_chrome: "Ajouter à Chrome",
    free: "Gratuit",
    try_now: "Essayer maintenant",
    screenshot: "Capture d'écran"
  }
}

